const urlData = [
    'author',
    // 'index',
    'login',
    'zdyx-clause'
  ];
  export default urlData;
  
  
  